import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import VConsole from "vconsole";

import App from "./App";
import store from "./services/Store";
import { PrimeReactProvider, PrimeReactContext } from "primereact/api";
import "./index.css";

// Initialize vConsole for mobile debugging
const vConsole = new VConsole();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <PrimeReactProvider>
    <Provider store={store}>
      <App />
    </Provider>
  </PrimeReactProvider>
);
